import { useState } from "react";
import { useTranslation } from "@localization/useTranslation";
import { PageHeaderEditEntityButtonMenuItem } from "../pageHeaderEditEntityButton/PageHeaderEditEntityButton";

// Entry to the plain (risk-free) entity graph from the entity pages' edit menu: the asset, processing
// activity, legal entity and process pages push the returned menu item into their existing PageHeaderEditEntityButton
// and render an EntityGraphDialog while isEntityGraphOpen.
export function useEntityGraphMenuItem() {
    const [isEntityGraphOpen, setIsEntityGraphOpen] = useState(false);
    const { translateString } = useTranslation();

    const entityGraphMenuItem: PageHeaderEditEntityButtonMenuItem = {
        menuItem: translateString("entityGraphOpen"),
        onClick: () => setIsEntityGraphOpen(true),
    };

    return {
        entityGraphMenuItem,
        isEntityGraphOpen,
        closeEntityGraph: () => setIsEntityGraphOpen(false),
    };
}
